import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { GraduationCap, BookOpen, Award } from 'lucide-react';

const education = [
  {
    institution: 'Glendale Community College',
    program: 'Computer Science & Cybersecurity',
    type: 'Coursework',
    icon: GraduationCap
  },
  {
    institution: 'University of Michigan (Coursera)',
    program: 'Python for Everybody',
    type: 'Certificate',
    icon: Award
  }
];

const professionalLearning = [
  'Learning PLC Ladder Logic (LinkedIn Learning)',
  'Cybersecurity Awareness: AI',
  'Software testing and automation fundamentals'
];

export const EducationSection = () => {
  return (
    <section id="education" className="py-20 md:py-28 bg-background">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Education & Development
          </h2>
          <div className="w-20 h-1 bg-primary mx-auto rounded-full mb-6" />
          <p className="text-muted-foreground max-w-2xl mx-auto text-base sm:text-lg">
            Continuous learning and professional development in technology 
            and IT systems.
          </p>
        </div>

        {/* Education Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
          {education.map((item, index) => (
            <Card key={index} className="bg-card border-border hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-primary-soft flex items-center justify-center flex-shrink-0">
                    <item.icon className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <span className="text-xs font-medium text-primary uppercase tracking-wider">
                      {item.type}
                    </span>
                    <h3 className="font-heading font-semibold text-lg text-foreground mt-1">
                      {item.program}
                    </h3>
                    <p className="text-muted-foreground text-sm mt-1">
                      {item.institution}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Professional Learning */}
        <Card className="bg-secondary/50 border-border">
          <CardContent className="p-6 md:p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-primary-soft flex items-center justify-center">
                <BookOpen className="w-5 h-5 text-primary" />
              </div>
              <h3 className="font-heading font-semibold text-xl text-foreground">
                Professional Learning
              </h3>
            </div>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {professionalLearning.map((item, index) => (
                <li key={index} className="flex items-center gap-3 text-muted-foreground">
                  <span className="w-2 h-2 rounded-full bg-primary flex-shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default EducationSection;
